import { render, staticRenderFns } from "./SurahAyah.vue?vue&type=template&id=c3ee19c4&"
import script from "./SurahAyah.vue?vue&type=script&lang=js&"
export * from "./SurahAyah.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports